import $ from 'jquery';

const ACTIVE = 'active';

export default class Navigation {
    constructor() {
        
        this.$header = $('header#global');
        this.$miniLinks = $('.mini-links--toggle');
        this.$nav = $('nav#global');
        this.$mobileSearch = $('.mobile-search--toggle');

        this.$header.on('click', '.jsMiniLinkSearch', $.proxy(this.handleMiniLinkSearch, this));
        this.$header.on('click', '.jsMenuToggle', $.proxy(this.handleMenuReveal, this));
        this.$header.on('click', '.jsMobileSearchReveal', $.proxy(this.handleMobileSearchReveal, this));
    }

    handleMenuReveal(e) {
        e.preventDefault();
        this.$nav.toggleClass(ACTIVE);
    }

    handleMobileSearchReveal(e) {
        e.preventDefault();
            
        this.$mobileSearch.toggleClass(ACTIVE);
    }

    handleMiniLinkSearch(e) {
        e.preventDefault();
        
        this.$miniLinks.toggleClass(ACTIVE);

        if( this.$miniLinks.hasClass(ACTIVE) ) {

            let miniLinks = this.$miniLinks;

            // make sure this delay is slightly longer than the animation from CSS
            // this can cause issues if not!
            window.setTimeout( () => {
                miniLinks.find('input[type="search"]').focus();
            }, 350 );

        } else {
            this.$miniLinks.find('input[type="search"]').blur();
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/components/navigation.js